import React, { useContext } from "react";
import { useTranslation } from "next-i18next";
import Styles from "./WhyChooseUs.module.scss";
import { useChooseusFeatures, useCustomerSaysData } from "../service-data/ServiceData";

import PageMetaTags from "../../common/page-meta-tags/PageMetaTags";

import Features from "../common/features/Features";
import HeroSection from "../common/hero-section/HeroSection";
import { AppContext } from "@vahak/core/dist/app-context";

import A from "@vahak/core/dist/components/app-anchor/A";
import AppBtn from "@vahak/core/dist/components/app-btn/AppBtn";
import AppImg from "components/utils/AppImg";

import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";
import OurCustomerSays from "../common/our-customer-says/OurCustomerSays";

const WhyChooseUs = () => {
    const { t } = useTranslation(["whyChooseUs"]);
    const { isMobile } = useContext(AppContext);

    return (
        <>
            <PageMetaTags
                title="Vahak - Why Choose Us"
                description="Running a transport business should be efficient. We help transporters digitize their business through easy online truck booking and online load booking."
                keywords="transport business, truck booking, truck booking app, online load booking, transport marketplace"
                canonicalUrl="https://www.vahak.in/why-choose-us"
                ogUrl="https://www.vahak.in/why-choose-us"
                ogImgAltText="Running a transport business should be efficient. We help transporters digitize their business through easy online truck booking and online load booking."
                schemaOrgJsonUrl="/why-choose-us"
                includeDefaultSchema={false}
                schemaType="WebPage"
            />

            <main className={Styles.main}>
                <HeroSection
                    bannerTitle={t("hero_section.section_title")}
                    bannerText={t("hero_section.section_text")}
                    hrefLabel={t("hero_section.cta_label")}
                    hrefURL="https://6r7cz.app.link/getvahak"
                    // srcSetURL={`${IMG_BASE_URL}/indian-transportation-service-providers_desktop_3x.png 1852w, ${IMG_BASE_URL}/indian-transportation-service-providers_desktop_2x.png 1234w, ${IMG_BASE_URL}/indian-transportation-service-providers_desktop.png 618w, ${IMG_BASE_URL}/indian-transportation-service-providers_mobile_3x.png 1034w, ${IMG_BASE_URL}/indian-transportation-service-providers_mobile_2x.png 689w, ${IMG_BASE_URL}/indian-transportation-service-providers_mobile.png 345w`}
                    srcURL={`indian-transportation-service-providers_desktop.png`}
                    sectionClass={Styles.whychooseusBanner}
                    imgboxClass={Styles.whychooseBannerImg}
                    textWrapClass={Styles.whychooseTextWrap}
                    imgColClass={Styles.whychooseImgCol}
                    altText="vahak main features"
                />

                <Features
                    features={useChooseusFeatures()}
                    sectionTitle={
                        <h2>
                            {t("features.section_title")} <span>{t("features.you")}</span>
                        </h2>
                    }
                    sectionText={`${t("features.section_text")}!`}
                    ctaLink="https://6r7cz.app.link/startusingvahak"
                    ctaLabel={t("features.cta_label")}
                />

                <OurCustomerSays
                    customerSaysData={useCustomerSaysData()}
                    sectionTitle={t("our_customer_says.section_titile")}
                    sectionText=""
                />

                <section className={Styles.ctaBanner}>
                    <A href="https://6r7cz.app.link/download-now" openInNewTab>
                        <div className="container">
                            <div className={Styles.ctaRow}>
                                <div className={Styles.ctaTextCol}>
                                    <h2>{t("cta_banner.cta_text")}</h2>
                                    <AppBtn className={Styles.btn}>
                                        {t("cta_banner.cta_btn_label")} <ArrowRightWhite />
                                    </AppBtn>
                                </div>
                                <div className={Styles.ctaImageCol}>
                                    <div className={Styles.imgBox}>
                                        <AppImg
                                            src={`indian-truck-transport-marketplace_desktop.png`}
                                            layout="responsive"
                                            alt="3 trucks on blue background"
                                            width={isMobile ? "236" : "495"}
                                            height={isMobile ? "131" : "230"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </A>
                </section>
            </main>
        </>
    );
};

export default WhyChooseUs;
